<template lang="pug">
  button.button(
    @click="buttonClick"
    :disabled="disabled"
  )
    slot(v-if="!isLoading")
    div(v-else)
      vue-loading(type='spin', color="#ffffff", :size="{ width: '30px', height: '30px' }")
</template>

<script>
import { VueLoading } from 'vue-loading-template'

export default {
  name: 'GbButton',
  components: {
    VueLoading
  },
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    isLoading: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    buttonClick ($e) {
      if (!this.isLoading) {
        this.$emit('clicked', $e)
      }
    }
  }
}
</script>

<style lang="stylus" scoped>
@import '../../stylus/main.styl'

.button {
  cursor pointer
  outline: none;
  border: none;
  margin: 8px;
  border-radius: 2px;
  height: 30px;
  width: 400px;
  font-size: 16px;
  letter-spacing: 1.8px;
  transition-duration: 0.2s;

  &.small {
    height: 24px;
    font-size: 12px;
  }

  &.effect {
    background-color: white;
    color: $color-secondary;
    border: 1px solid $color-secondary;
    width: 150px;
    font-size: 16px;
  }

  &.effect-search {
    background-color: white;
    color: $color-secondary;
    border: 1px solid $color-secondary;
    width: 50px;
    font-size: 16px;
  }

  &.primary {
    background-color: $color-primary;
    color: #fff;

    &:hover {
      background-color: lighten($color-primary, 5%);
    }

    &:active {
      background-color: lighten($color-primary, 10%);
      box-shadow: 0 4px 8px rgba(42, 54, 63, 0.25);
    }

    &:disabled {
      background-color: $color-primary;
      box-shadow: none;
    }
  }

  &.secondary {
    background-color: $color-secondary;
    color: #fff;

    &:hover {
      background-color: lighten($color-secondary, 5%);
    }

    &:active {
      background-color: lighten($color-secondary, 10%);
      box-shadow: 0 4px 8px rgba(42, 54, 63, 0.25);
    }

    &:disabled {
      background-color: $color-secondary;
      box-shadow: none;
    }
  }

  &.info {
    background-color: $color-info;
    color: #fff;

    &:hover {
      background-color: lighten($color-info, 5%);
    }

    &:active {
      background-color: lighten($color-info, 10%);
      box-shadow: 0 4px 8px rgba(42, 54, 63, 0.25);
    }

    &:disabled {
      background-color: $color-info;
      box-shadow: none;
    }
  }

  &.disabled {
    background-color: $color-disable;
    color: #fff;

    &:hover {
      background-color: lighten($color-disable, 5%);
    }

    &:active {
      background-color: lighten($color-disable, 10%);
      box-shadow: 0 4px 8px rgba(42, 54, 63, 0.25);
    }

    &:disabled {
      background-color: $color-disable;
      box-shadow: none;
    }
  }

  &.danger {
    background-color: $color-danger;
    color: #fff;

    &:hover {
      background-color: lighten($color-danger, 5%);
    }

    &:active {
      background-color: lighten($color-danger, 10%);
      box-shadow: 0 4px 8px rgba(42, 54, 63, 0.25);
    }

    &:disabled {
      background-color: $color-disable;
      box-shadow: none;
    }
  }

  &.text-primary {
    color: $color-primary;
    font-weight: 400;

    &:hover {
      background-color: lighten($color-primary, 95%);
    }
  }

  &.text-secondary {
    color: $color-secondary;
    font-weight: 400;

    &:hover {
      background-color: lighten($color-secondary, 95%);
    }
  }

  &.text-danger {
    color: $color-danger;
    font-weight: 600;
    font-size: 14px;
    width: 200px;

    &:hover {
      background-color: lighten($color-danger, 95%);
    }
  }
  &.text-edit {
    color: $color-secondary;
    font-weight: 600;
    font-size: 14px;
    width: 200px;
    &:hover {
      background-color: lighten($color-secondary, 95%);
    }
  }

  &.dammy-edit {
    color: $color-primary;
    font-weight: 600;
    font-size: 14px;
    width: 200px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/atoms/GbButton.vue